import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GameBreadcrumb from "../components/GameBreadcrumb.js";

const DesignHtml = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [endPoint, setEndPoint] = useState();
  const [gameType, setGameType] = useState();
  const [levelName, setLevelName] = useState();
  const [levelNumber, setLevelNumber] = useState();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLevelName(sessionStorage.getItem("levelName"));
      setLevelNumber(sessionStorage.getItem("levelNumber"));

      let endpoint = null;
      const pathParts = pathname.split("/").filter(Boolean);
      const level = pathParts[2];

      if (pathname.includes("quiz-game")) {
        setGameType("Quiz");
        endpoint = "/quiz";
      } else if (pathname.includes("one-word-game")) {
        setGameType("One Word");
        endpoint = "/one-word";
      } else if (pathname.includes("calculation-game")) {
        setGameType("Calculation");
        endpoint = "/calculation";
      }
      setEndPoint(pathname);
      if (!endpoint) return;

      try {
        endpoint = `${endpoint}/admin/summary?game_number=${level}`;

        // if (pathname.includes("calculation-game") ||pathname.includes("one-word-game") ) {
        //   endpoint = `${endpoint}?game_number=${level}`;
        // }
        const response = await api.get(endpoint);
        setRoles(response.data.data);
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false);
    };

    fetchData();
  }, [pathname]);

  const getSetId = (role) => {
    if (pathname.includes("quiz-game")) {
      return role.user_type;
    } else if (pathname.includes("one-word-game")) {
      return role.level;
    } else if (pathname.includes("calculation-game")) {
      return role.level;
    }
  };

  const goToSet = (id) => {
    navigate(`${id}`);
  };

  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <GameBreadcrumb quizId="" />

                        <h1 className="mb-2 mt-3">
                          Level {levelNumber}: {levelName}
                        </h1>
                        <p className="text-white mb-1">Game: {gameType}</p>
                        <div className="hstack gap-2 gap-sm-4">
                          {/* <span className='text-white'>Total Questions Available: 105</span> */}
                        </div>
                      </div>
                      <div className="d-flex flex-end">
                        <a href="#!" className="secondary_btn py-2 px-4">
                          Back
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>{gameType === "Quiz" ? "Roles" : "Levels"}</h2>
                        </div>
                      </div>
                      <div className="common-right-blk">
                        <div className="common-sort-blk">
                          {/* <div className="common-search-blk">
                            <input
                              type="search"
                              className="form-control"
                              id="search"
                              placeholder="Search questions across all roles"
                            />
                          </div> */}
                          {/* <select name="" id="" className="form-select">
                            <option value="Select Game">All status</option>
                            <option value="All Game">Approved</option>
                            <option value="Quiz Game">Pending</option>
                          </select> */}
                          {/* <button className="secondary_btn py-2 fs-14">
                            Add Questions to role
                          </button>
                          <button className="secondary_btn py-2 fs-14">
                            Bulk Import Questions
                          </button> */}
                        </div>
                      </div>
                    </div>
                    <div className="common_content_blk">
                      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-3 g-4">
                        {roles.map((role) => (
                          <div className="col">
                            <div className="quiz_card_wrapper">
                              {pathname.includes("quiz-game") ? (
                                <div className="hstack gap-3 mb-4">
                                  <div className="role_icon">
                                    <img src={role.logo} />
                                    {/* <i className="fa-solid fa-user-graduate"></i> */}
                                  </div>
                                  <div className="flex-grow-1">
                                    <h3 className="mb-0 text-capitalize">{role.user_type}</h3>
                                  </div>
                                </div>
                              )
                              
                              : 
                                <div className="hstack gap-3 mb-4">
                                  <div className="flex-grow-1">
                                    <h3 className="mb-0 text-capitalize">{role.level.replace("_", " ")}</h3>
                                  </div>
                                </div>
                              }

                              {role.description && (
                                <p>
                                  <span>Description:</span>
                                  {role.description}
                                </p>
                              )}

                              <p>
                                <span>Total Questions:</span> {role.total} Sets   {role.level}
                               </p>
                              {/* <p><span>Question Range:</span> 10-20 questions per quiz set</p> */}
                              {/* <p><span>Status:</span> <span className='st_incomplete'>Incomplete</span></p> */}
                              <p>
                                <span>Approved Questions:</span> {role.approved}{" "}
                                Questions
                              </p>
                              <p>
                                <span>Pending Questions:</span>{" "}
                                {role.unapproved} Questions
                              </p>
                              {/* <p><span>Draft Questions:</span> 2 questions</p> */}
                              <div className="mt-4">
                                <button
                                  onClick={() => goToSet(getSetId(role))}
                                  className="secondary_btn py-2 px-4 w-100 justify-content-center"
                                >
                                  View Sets
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default DesignHtml;
